import { TimelineFilters, CurationFiltersUtils } from '@/types/filter'
import { FilterItem } from '../types'

export function parseFilterIds(
  filters: TimelineFilters | CurationFiltersUtils
): {
  territoryIds: string[]
  contextIds: string[]
  topicIds: string[]
  partnerIds: string[]
  sourceIds: string[]
} {
  const split = (s: string | undefined) => s?.split(';').filter(Boolean) || []
  return {
    territoryIds: split(filters.territories),
    contextIds: split(filters.contexts),
    topicIds: split(filters.topics),
    partnerIds: split(filters.partners),
    sourceIds: split(filters.sources),
  }
}

export function resolveItemsByIds<T extends { id: string; name: string }>(
  all: T[],
  ids: string[]
): FilterItem[] {
  if (ids.length === 0) return []
  return all.filter((item) => ids.includes(item.id)).map((item) => ({ id: item.id, name: item.name }))
}
